/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ConfigurazioneFormCittadinoDTO } from '../model/configurazione-form-cittadino-dto';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    CittadinoConfigurazioneFormBandoServiceInterface,
    GetConfigurazioneFormCittadinoRequestParams
} from './cittadino-configurazione-form-bando.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class CittadinoConfigurazioneFormBandoService extends BaseService implements CittadinoConfigurazioneFormBandoServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Restituisce la configurazione del form cittadino del bando in formato legacy-shape JSON con i $dynamic placeholder gia\&#39; espansi dai satelliti. Il path variable {idTp} accetta sia l\&#39;UUID sia il codice del bando (risolto entro il comune).
     * Con ?anteprima&#x3D;true il gate di visibilita\&#39; rilassa SOLO lo stato del bando (anche IN_ATTESA), mantenendo il vincolo visualizzazione&#x3D;PUBBLICA e l\&#39;appartenenza al comune: consente l\&#39;anteprima del form di un bando in bozza. Nessuna autenticazione richiesta (comportamento identico per anonimi e loggati). La sottomissione resta comunque bloccata per i bandi non ancora sottomettibili.
     * @endpoint get /api/v1/cittadino/comuni/{slug}/tipi-pratica/{idTp}/configurazione-form
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getConfigurazioneFormCittadino(requestParameters: GetConfigurazioneFormCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ConfigurazioneFormCittadinoDTO>;
    public getConfigurazioneFormCittadino(requestParameters: GetConfigurazioneFormCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ConfigurazioneFormCittadinoDTO>>;
    public getConfigurazioneFormCittadino(requestParameters: GetConfigurazioneFormCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ConfigurazioneFormCittadinoDTO>>;
    public getConfigurazioneFormCittadino(requestParameters: GetConfigurazioneFormCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const slug = requestParameters?.slug;
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling getConfigurazioneFormCittadino.');
        }
        const idTp = requestParameters?.idTp;
        if (idTp === null || idTp === undefined) {
            throw new Error('Required parameter idTp was null or undefined when calling getConfigurazioneFormCittadino.');
        }
        const anteprima = requestParameters?.anteprima;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'anteprima',
            <any>anteprima,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/comuni/${this.configuration.encodeParam({name: "slug", value: slug, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/tipi-pratica/${this.configuration.encodeParam({name: "idTp", value: idTp, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/configurazione-form`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ConfigurazioneFormCittadinoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
